<div class="d-inline-flex">
  <ncp-button
    #addPregnancyButton
    [options]="btnPHOptions()"
  >
    @if(phLoading) {
      <div class="loading spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    } @else {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.people.pregnant.src"
        width="18"
        height="18"
        alt="Add Pregnancy"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="pregnancies_form"
      name="pregnancies_form"
      [formGroup]="form"
      #phFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #pregnancyDesc [(options)]="pregnancyDescDDOptions" />
      <ncp-date #pregnancyDate [(options)]="pregnancyDateOptions" />
    </form>
  </ncp-modal>
</div>
